// 定义心愿单侧边栏组件
if (!customElements.get("wishlist-drawer")) {
  class WishlistDrawer extends Drawer {
    unsubscriber = undefined;

    constructor() {
      super();
      this.cache = {
        url: null, // 上次请求的URL缓存
        controller: null, // 当前fetch的AbortController
      };
      this.contentContainer = this.querySelector(".content-container");
      this.recommendationByHistory = this.querySelector(
        "recommendation-by-history",
      ); // 最近浏览推荐

      // 添加变化监听，重置url
      this.unsubscriber = webvista.subscribe(
        PUB_SUB_EVENTS.wishUpdated,
        ()=>{
          this.cache.url = null;
        }
      );
    }

    disconnectedCallback() {
      this.cache.controller?.abort();
      this.recommendationByHistory?.abortFetch();
      if(this.unsubscriber) this.unsubscriber();
    }

    /**
     * 显示抽屉并加载数据
     * @param {HTMLElement} opener - 触发打开的元素
     */
    show(opener) {
      super.show(opener);

      const url = this.constructQueryUrl();
      if(url == null) return this.showEmptyState();
      if (url === this.cache.url) return;

      this.cache.url = url; // 缓存当前URL
      this.showLoadingState();

      // 取消之前的请求
      this.cache.controller?.abort();
      this.cache.controller = new AbortController();

      webvista
        .fetchHtml(url, this.cache.controller.signal)
        .then((html) => this.handleSuccessResponse(html))
        .catch(() => this.showEmptyState());

      // 加载推荐
      if (this.recommendationByHistory)
        this.recommendationByHistory.showContent();
    }

    hide() {
      super.hide();

      this.cache.controller?.abort();
      this.recommendationByHistory?.abortFetch();
    }

    /**
     * 处理成功响应
     * @param {Document} html - 返回的HTML文档
     */
    handleSuccessResponse(html) {
      const templateContent = html.querySelector(
        "template.template-content",
      ).content;

      if (templateContent.hasChildNodes()) {
        // 处理排序
        const fragment = document.createDocumentFragment();
        this.ids = this.ids.filter((id) => {
          const item = templateContent.querySelector(
            `.card-wrapper[data-id="${id}"]`,
          );
          if (item) {
            fragment.appendChild(item);
            return true;
          }
          return false;
        });

        // 重新存储有效id
        webvista.storeData(WISHLIST_PRODUCT_KEY, this.ids.reverse());

        // 替换内容
        this.contentContainer.innerHTML = "";
        this.contentContainer.append(fragment);
        webvista.initLazyImages(); // 初始化懒加载图片
      } else {
        this.showEmptyState();
      }
    }

    /**
     * 构建查询URL
     * @returns {string|null} 返回构造好的URL或null（当无数据时）
     */
    constructQueryUrl() {
      this.ids =
        webvista
          .retrieveData(WISHLIST_PRODUCT_KEY)
          ?.slice(-30) // 只取最近30条
          ?.reverse() ?? // 倒序显示最新添加
        [];

      if (!this.ids.length) return null;

      const params = new URLSearchParams({
        q: this.ids.map((id) => `id:${id}`).join(" OR "), // 构造OR查询
        type: "product",
        section_id: this.dataset.section,
        ose: "false", // 禁用搜索引擎优化
      });

      return `${this.dataset.searchUrl}?${params.toString()}`;
    }

    /**
     * 显示加载状态
     */
    showLoadingState() {
      this.querySelector(".drawer-content").classList.remove("is-empty");
      this.contentContainer.innerHTML = this.querySelector(
        "template.template-placeholder",
      ).innerHTML;
    }

    /**
     * 显示空状态
     */
    showEmptyState() {
      this.querySelector(".drawer-content").classList.add("is-empty");
      this.contentContainer.innerHTML = "";
    }
  }

  customElements.define("wishlist-drawer", WishlistDrawer);
}

// 定义移除心愿单按钮组件
if (!customElements.get("remove-wish")) {
  class RemoveWish extends HTMLElement {
    constructor() {
      super();
      if (!this.dataset.id) return;

      // 使用箭头函数避免绑定this
      this.onClick = () => this.handleClick();
      this.addEventListener("click", this.onClick);
    }

    /**
     * 处理点击事件
     */
    handleClick() {
      const ids = webvista.retrieveData(WISHLIST_PRODUCT_KEY) || [];
      const itemIndex = ids.indexOf(this.dataset.id);
      if (itemIndex === -1) return;

      // 创建新数组而非修改原数组
      const updatedIds = [...ids];
      updatedIds.splice(itemIndex, 1);

      webvista.storeData(WISHLIST_PRODUCT_KEY, updatedIds);
      this.animateRemoval();

      // 如果清空则更新抽屉状态
      if (updatedIds.length <= 0) {
        this.closest("wishlist-drawer")?.showEmptyState();
      }

      // 发送移除广播
      webvista.publish(PUB_SUB_EVENTS.wishUpdated, {
        id: this.dataset.id,
        type: "remove",
        source: this.id,
      });
    }

    /**
     * 执行移除动画
     */
    animateRemoval() {
      const card = this.closest(".card");
      if (!card) return;

      card.style.transition = "opacity 0.3s ease";
      card.style.opacity = "0";

      // 动画结束后移除元素
      const onTransitionEnd = () => {
        card.removeEventListener("transitionend", onTransitionEnd);
        card.remove();
      };

      card.addEventListener("transitionend", onTransitionEnd);
    }

    /**
     * 组件卸载时清理事件监听
     */
    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
    }
  }

  customElements.define("remove-wish", RemoveWish);
}
